<script>
    import { format } from "svelte-i18n";
    let { limits_diff } = $props();

    let visible = $state(true);
</script>

{#if visible}
<div class="alert alert-warning alert-dismissible">
    <button type="button" class="btn-close" aria-hidden="true" onclick={() => visible = false}></button>

    <h5><i class="icon fas fa-exclamation-triangle"></i> {$format("components.limits_alert.title")}</h5>
    <div>
        {$format("components.limits_alert.limit_reached")}
        ({#each Object.entries(limits_diff) as [asset_kind, diff], idx}
            {#if diff < 1}
                {$format(`asset.kind.${asset_kind}.plural`)}{#if idx < Object.entries(limits_diff).length -1},&nbsp;{/if}
            {/if}
        {/each}).
        <a href="mailto:vulseek@securetia.com">{$format("components.limits_alert.contact_us")}</a> {$format("components.limits_alert.upgrade_plan")}
    </div>
</div>
{/if}

<style>
    a {
        color: inherit !important;
    }
</style>